import { getAPIUrl } from '@utils/url'
import { normalizeUserSession, UserSession } from 'models/User'

const GET_USER_ERROR_MESSAGES: Record<number, string> = {
  404: 'No se encuentra el usuario',
}

export class UserSessionRequestError extends Error {
  status: number

  constructor(status: number, statusText: string) {
    super(GET_USER_ERROR_MESSAGES[status] ?? `Error ${status}: ${statusText}`)
    this.name = 'UserSessionRequestError'
    this.status = status
  }
}

export const getUser = async (signal?: AbortSignal): Promise<UserSession> => {
  const response = await fetch(getAPIUrl('/users/profile'), {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    signal,
  })

  if (!response.ok) {
    throw new UserSessionRequestError(response.status, response.statusText)
  }

  const data = await response.json()

  return normalizeUserSession(data)
}
